import clsx from '@/lib/clsx';

const WizardRightPanel = ({ children, className = '', ...props }) => {
  return (
    <div className={clsx('comp-wizard-right-panel', className)} {...props}>
      {children}
    </div>
  );
};

export default WizardRightPanel;
